import { dateStringSerializer } from "@megaron/date-string";
import { HttpAction } from "@megaron/http-service";
import { Serializers } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

const claimCashReward = HttpAction({
  path: "/rewards/claim",
  method: "post",
  requiresAuth: true as const,
  bodySerializer: Serializers.object({
    rewardId: Serializers.string,
    listingUuid: uuidSerializer,
  }),
  valueSerializer: Serializers.object({
    purchaseId: uuidSerializer,
  }),
  errorSerializer: Serializers.stringOneOf(
    "NotEnoughPoints",
    "ProStatusRequired",
    "ListingUnavailable",
    "RewardNotListed",
    "ListingNotFound",
    "InvalidRewardType",
  ),
});

export const rewardActions = {
  claimCashReward,

  monthlyCashRewardsToSheets: HttpAction({
    path: "/monthlyCashRewardsToSheets",
    method: "post",
    requiresAuth: true as const,
    bodySerializer: Serializers.object({
      sheetId: Serializers.string,
      month: dateStringSerializer.optional(),
    }),
  }),
};
